module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0041.jpg?v=f71a98d9";